export default __webpack_public_path__ + "static/media/Packages.88156975.svg";